import React from 'react'

import {
  Button,
  Flex,
  Heading,
  Image,
  useMediaQuery,
  Box,
  VStack,
  Text,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Input
} from "@chakra-ui/react";
import "../style.scss";
import resgateLogo from 'assets/resgate/resgate-logo.png';

const ErrorMessage = (props: any) => {
 
    return (
    <Box>
        <div className='resgate_logo'><Image src={resgateLogo} alt="Resgate PIX" style={{width: '500px'}} /></div>
        <div className='resgate_process_content'>{props.children}</div>
    </Box>
    );
}

export default ErrorMessage